
declare var $: any;
export class EvsErr {
    static evs_err(res:any={},show:any=true, message:any = {content: '', class: ''}){
        // let message = {content: '', class: ''};

        if(res.status != 401){
            if(typeof res == 'string' && show){
                message = {content: res, class: 'warning'}
            }else if(typeof res == 'object' && show){
                let body = $("html, body");
                body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
                message = {content: res.message, class: 'danger'}
            }else {
                // console.log('Chắc chắn sai ở đâu đó rồi !');
                // console.log('response: ', res);
                console.log('response');
            }
        }

        return message;
    }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/evsErr.ts